<template>
    <div class="history">
<!--        <h2 class="title AvantGarde">GROUP HISTORY AND ACHIEVEMENTS</h2>-->
        <h2 class="title AvantGarde">OUR HISTORY</h2>
        <h3 class="title-cn YaSiRegular"></h3>
			<svg version="1.1" id="svg-pc-new" class="pc" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
					 viewBox="0 0 1920 700" style="enable-background:new 0 0 1920 700;" xml:space="preserve">
				<g>
	<defs>
		<rect id="SVGID_1_" x="67.3" y="-3.9" width="1836.5" height="668.7"/>
	</defs>
					<clipPath id="SVGID_00000047776715455280685030000015397082045748024754_">
		<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
	</clipPath>
					<g style="clip-path:url(#SVGID_00000047776715455280685030000015397082045748024754_);">
		<g>
			<path class="st1" d="M377.1,667.3c-8.4,0-17,0-26,0h-28.9c-66,0-74.9-43.7-74.9-86.4V384.6c0-54.1-20.9-80.4-63.8-80.4H67.3V296
				h116.2c32.9,0,72,15.4,72,88.6V581c0,46.9,11.3,78.2,66.7,78.2h28.9c56.5,0,101.2,0.1,136.1-1.6c32.3-1.5,59-8.7,58-80.9
				l-0.9-68.3c-1-72.3-2.1-158.2-2.8-225.4v-2.2c-0.3-20.5-0.7-54.8,21.4-77.1c14.3-14.5,36-21.8,64.6-21.8h183.2
				c0.8,0,69.6,2.7,69.6,94.9v188.8c0,27,0,52.6,8.8,70.3c9.5,19,28.9,27.9,61,27.9h209.3c2.3-0.1,58.8-2.9,58.8-91.3
				c0-31.1,0.2-66.3,0.4-100.4c0.4-69.2,0.9-140.7-0.4-185.9l-0.1-3.8c-0.8-23.3-2.2-66.7,21.7-91.4c12-12.4,28.8-18.6,50.2-18.6
				h201.1c65.7,0,70.6,43.8,70.6,110.5c0,25.6,0.2,45.2,0.3,60.9c0.2,23.5,0.3,39-0.3,52.9c-0.9,19.1-0.8,40.6,12.4,54.3
				c10,10.5,26.2,15.5,49.6,15.5c65.4,0,276.5,1.6,278.6,1.6l-0.1,8.2c-2.1,0-213.2-1.6-278.5-1.6c-25.8,0-44-5.9-55.6-18.1
				c-15.4-16.1-15.6-39.6-14.6-60.4c0.6-13.7,0.5-29.1,0.3-52.4c-0.1-15.8-0.3-35.4-0.3-61c0-69.5-6.2-102.3-62.4-102.3H1290
				c-19,0-33.9,5.4-44.2,16.1c-21.5,22.2-20.2,61.7-19.4,85.4l0.1,3.8c1.3,45.3,0.9,116.9,0.4,186.2c-0.2,34-0.4,69.2-0.4,100.3
				c0,50.2-18,74.6-33.1,86.2c-16.6,12.8-33.2,13.4-33.9,13.4H950.1c-35.7,0-57.4-10.3-68.4-32.4c-9.7-19.4-9.7-45.9-9.7-74V276.6
				c0-83.9-58.9-86.6-61.5-86.7H627.4c-26.3,0-46.1,6.5-58.8,19.4c-19.6,19.9-19.2,50.8-19,71.3v2.2c0.7,67.2,1.9,153.2,2.8,225.4
				l0.9,68.3c1,79.4-32,87.6-65.9,89.2C458.1,667.2,421.7,667.3,377.1,667.3z"/>
		</g>
	</g>
</g>
				<path class="st2 " style="stroke:#ccc" d="M69.3,300.6c0,0,31.5,0.1,112.3-0.5c63.3-0.5,69.4,60.1,69.7,72.4l-0.6,181.8l0.8,39
	c1.4,69.7,54.7,68.3,62.5,68.7l150.2,0.3c47.3,0,86.3-2.5,85.5-78.5L546,312.2l-0.7-37.7c0-44,13.1-92.2,87.7-88.9l173.7-0.3
	c51,6.3,70.5,43.3,69.8,102.8l-1.2,148v41c4.3,35.6-8.3,91.5,82.3,90.5l190.7,1.3c47.3,0,76.2-41,73.6-92.4l0-299.8
	c0,0-10-103,67.7-100l202.7-0.2c47.3,0,66.2,23.5,65.2,95.2l-0.3,139.1c0,44,21.6,60.1,68.9,60.1L1902,372"/>
				<path class="st2 blue-long" d="M69.3,300.6c0,0,31.5,0.1,112.3-0.5c63.3-0.5,69.4,60.1,69.7,72.4l-0.6,181.8l0.8,39
	c1.4,69.7,54.7,68.3,62.5,68.7l150.2,0.3c47.3,0,86.3-2.5,85.5-78.5L546,312.2l-0.7-37.7c0-44,13.1-92.2,87.7-88.9l173.7-0.3
	c51,6.3,70.5,43.3,69.8,102.8l-1.2,148v41c4.3,35.6-8.3,91.5,82.3,90.5l190.7,1.3c47.3,0,76.2-41,73.6-92.4l0-299.8
	c0,0-10-103,67.7-100l202.7-0.2c47.3,0,66.2,23.5,65.2,95.2l-0.3,139.1c0,44,21.6,60.1,68.9,60.1L1902,372"/>
				<g>
	<path class="st3" d="M409.6,562.3c0,12.6-10.2,22.6-22.6,22.6c-12.6,0-22.6-10-22.6-22.6c0-12.6,10.2-22.6,22.6-22.6
		c7.3,0,13.6,3.5,17.8,8.7 M386.8,546.1v14.6 M388.1,564.1l7.5,7.6"/>
					<circle class="st3" cx="387" cy="562.3" r="1.8"/>
					<path class="st3" d="M401.9,548.8l3.6,0.7l0.2-3.6"/>
					<path class="st3" d="M425,519.2h4.7c5.3,0,9.6,4.4,9.6,9.6v63.7c0,5.5-4.4,9.6-9.6,9.6H344c-5.3,0-9.6-4.4-9.6-9.6v-63.7
		c0-5.3,4.4-9.6,9.6-9.6h6.7 M365,519.2h44.6"/>
					<path class="st3" d="M359.3,507.2h-2.2c-3.1,0-5.6,2.5-5.6,5.6v9.8c0,3.1,2.5,5.6,5.6,5.6h2.2c3.1,0,5.6-2.5,5.6-5.6v-9.8
		C365,509.7,362.4,507.2,359.3,507.2z M418.5,507.2h-2.2c-3.1,0-5.6,2.5-5.6,5.6v9.8c0,3.1,2.5,5.6,5.6,5.6h2.2
		c3.1,0,5.6-2.5,5.6-5.6v-9.8C424.1,509.7,421.6,507.2,418.5,507.2z"/>
</g>
        <g data-v-18923eba="" data-v-7c1d31f8=""><path data-v-18923eba="" data-v-7c1d31f8="" d="M701.7,321.9l7.3-69.6h14.6l2.3,23.2" class="" style="fill: transparent; stroke-miterlimit: 10; stroke: rgb(183, 183, 183);"></path><path data-v-18923eba="" data-v-7c1d31f8="" d="M721.7,321.9v-48.3l30.1,15.6v-15.6l28.1,15.6v-15.6h31.9v48.3 M749.9,218.9c0,0-11.1-9.7-19.2-2.4
		c-5,4.5-3.3,16.3-3.3,16.3s0-0.2-0.2-0.3c-2.4-5-9.5-3.5-8.7,3.3c0.2,0.9,0.7,1.9,1.4,2.8c-4.9-1.2-6.4,2.9-5,6.2
		c-5.5-0.7-5.2,6.8-2.3,8" style="fill: transparent; stroke: rgb(183, 183, 183); stroke-miterlimit: 10;"></path><path data-v-18923eba="" data-v-7c1d31f8="" d="M720.1,251.4c0,0,2.6-2.1,0.7-6.4c5.5,0.2,7.4-0.9,8-5.9c6.8,1.9,8.8-0.2,9.5-4.3c1.7,3.3,5.5,6.6,9.4,4
		c4.2-2.8,2.3-9,1.7-10.7 M725.8,321.9v-6.1H739v6.1 M753.5,321.9v-6.1h13.2v6.1 M781.8,321.9v-6.1h13.2v6.1 M687.4,321.9h137v11.6
		h-137V321.9z M783.8,278.5h6.9v4.2h-6.9V278.5z M783.8,286.1h6.9v4.2h-6.9V286.1z M800.5,278.5h6.9v4.2h-6.9V278.5z M800.5,286.1
		h6.9v4.2h-6.9V286.1z" style="fill: transparent; stroke: rgb(183, 183, 183); stroke-miterlimit: 10;"></path></g>
        <g data-v-18923eba="" data-v-7c1d31f8=""><path data-v-18923eba="" data-v-7c1d31f8="" d="M1421.8,604.7v-37.9c0-8.8-7-15.8-15.8-15.8h-75c-8.8,0-15.8,7-15.8,15.8v37.9H1421.8L1421.8,604.7z" class="" style="fill: transparent; stroke: rgb(183, 183, 183); stroke-miterlimit: 10;"></path><path data-v-18923eba="" data-v-7c1d31f8="" d="M1315.3,580.1h50c1.8,0,3.3,1.3,3.3,2.6v19.1 M1421.8,580.1h-50c-1.8,0-3.3,1.3-3.3,2.6v19.1" class="" style="fill: transparent; stroke: rgb(183, 183, 183); stroke-miterlimit: 10;"></path><path data-v-18923eba="" data-v-7c1d31f8="" d="M1315.3,581c0,0-2.2-3.3-7-2.8s-5.7,3.7-6.1,5.3c-0.4,1.5,0,28.7,0,28.7s0.2,3.7,6.6,3.7h122.7
		c0,0,4.4-0.2,4.4-4.6v-26.7c0-2.2-1.1-4.6-3.1-5.7c-1.3-0.9-3.1-1.3-5.3-0.9c-3.1,0-5.5,2.2-5.5,4.4" class="" style="fill: transparent; stroke: rgb(183, 183, 183); stroke-miterlimit: 10;"></path><path data-v-18923eba="" data-v-7c1d31f8="" d="M1425.5,615.8v12.7c0,1.5-1.1,2.6-2.6,2.6h-3.5c-1.5,0-2.6-1.3-2.6-2.6v-12.7 M1319.7,615.8v12.7
		c0,1.5-1.1,2.6-2.6,2.6h-3.5c-1.5,0-2.6-1.3-2.6-2.6v-12.7" class="" style="fill: transparent; stroke: rgb(183, 183, 183); stroke-miterlimit: 10;"></path></g>
				<g class="a1 ani">
	<g>
		<path class="st4" d="M252.5,367.6c4.6,0,8.3,3.7,8.3,8.3c0,4.6-3.7,8.3-8.3,8.3c-4.6,0-8.3-3.7-8.3-8.3
			C244.2,371.5,247.9,367.6,252.5,367.6z M240.7,374h4.2v4.2h-4.2V374z M232.4,374h4.2v4.2h-4.2V374z M224.1,374h4.2v4.2h-4.2V374z
			 M215.8,374h4.2v4.2h-4.2V374z M207.5,374h4.2v4.2h-4.2V374z M199.2,374h4.2v4.2h-4.2V374z"/>
		<path class="st5" d="M252.5,385.9c-4.2,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.5-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8C262.4,381.5,258,385.9,252.5,385.9z M246.3,378.6c1,2.4,3.5,4.1,6.3,4.1
			c3.7,0,6.8-3,6.8-6.8s-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2C246.4,378.2,246.4,378.5,246.3,378.6z
			 M242.2,376.5h0.5c0-0.2,0-0.4,0-0.6s0-0.4,0-0.6h-0.5V376.5z M236.6,379.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C238.1,379,237.4,379.5,236.6,379.5z M233.9,376.5h1.1v-1.1h-1.1V376.5z
			 M228.3,379.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C229.8,379,229.1,379.5,228.3,379.5z M225.6,376.5h1.1v-1.1h-1.1V376.5z M219.9,379.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C221.5,379,220.8,379.5,219.9,379.5z M217.3,376.5h1.1v-1.1h-1.1V376.5z
			 M211.6,379.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C213.2,379,212.5,379.5,211.6,379.5z M209,376.5h1.1v-1.1H209V376.5z M203.3,379.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C204.9,379,204.2,379.5,203.3,379.5z M200.7,376.5h1.1v-1.1h-1.1V376.5z"/>
	</g>
					<text transform="matrix(1 0 0 1 121.0087 360.3543)" class="st6 st7 st8">1987</text>
					<text transform="matrix(1 0 0 1 38.1439 378.4451)"><tspan x="0" y="0" class="st9 st6 st10">CEO came Shanghai</tspan><tspan x="-7.5" y="21.1" class="st9 st6 st10">to study Chinese and</tspan><tspan x="27.8" y="42.1" class="st9 st6 st10">Chinese culture</tspan></text>
</g>
				<g class="a6 ani">
	<g>
		<path class="st4" d="M546.5,313.6c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3s-8.3-3.7-8.3-8.3S541.9,313.6,546.5,313.6z M534.7,320
			h4.2v4.2h-4.2V320z M526.4,320h4.2v4.2h-4.2V320z M518.1,320h4.2v4.2h-4.2V320z M509.8,320h4.2v4.2h-4.2V320z M501.5,320h4.2v4.2
			h-4.2V320z M493.2,320h4.2v4.2h-4.2V320z"/>
		<path class="st5" d="M546.5,331.9c-4.1,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.4-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8C556.4,327.5,552,331.9,546.5,331.9z M540.3,324.6c1,2.4,3.4,4.1,6.3,4.1
			c3.7,0,6.8-3,6.8-6.8s-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2C540.4,324.2,540.4,324.5,540.3,324.6z
			 M536.2,322.5h0.5c0-0.2,0-0.4,0-0.6s0-0.4,0-0.6h-0.5V322.5z M530.6,325.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C532.1,324.9,531.4,325.5,530.6,325.5z M527.9,322.5h1.1v-1.1h-1.1V322.5z
			 M522.3,325.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
			C523.8,324.9,523.1,325.5,522.3,325.5z M519.6,322.5h1.1v-1.1h-1.1V322.5z M513.9,325.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C515.5,324.9,514.8,325.5,513.9,325.5z M511.3,322.5h1.1v-1.1h-1.1V322.5z
			 M505.6,325.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C507.2,324.9,506.5,325.5,505.6,325.5z M503,322.5h1.1v-1.1H503V322.5z M497.3,325.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C498.9,324.9,498.2,325.5,497.3,325.5z M494.7,322.5h1.1v-1.1h-1.1V322.5z"
		/>
	</g>
					<text transform="matrix(1 0 0 1 411.8597 307.1044)" class="st6 st7 st8">1997</text>
					<text transform="matrix(1 0 0 1 315.2611 325.1952)"><tspan x="0" y="0" class="st9 st6 st10">A small workshop was</tspan><tspan x="-6.7" y="21.1" class="st9 st6 st10">established to produce</tspan><tspan x="4.3" y="42.1" class="st9 st6 st10">sofas with Boconcept</tspan></text>
</g>
				<g class="a9 ani">
	<g>
		<path class="st4" d="M1224.5,392.6c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S1229.1,392.6,1224.5,392.6z
			 M1236.3,398.9h-4.2v4.2h4.2V398.9z M1244.6,398.9h-4.2v4.2h4.2V398.9z M1252.9,398.9h-4.2v4.2h4.2V398.9z M1261.2,398.9h-4.2v4.2
			h4.2V398.9z M1269.5,398.9h-4.2v4.2h4.2V398.9z M1277.8,398.9h-4.2v4.2h4.2V398.9z"/>
		<path class="st5" d="M1224.5,410.8c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C1232.2,408.1,1228.6,410.8,1224.5,410.8z M1224.5,394.1c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C1229.7,395.9,1227.3,394.1,1224.5,394.1z
			 M1234.3,401.5h0.5v-1.1h-0.5c0,0.2,0,0.4,0,0.6C1234.3,401.1,1234.3,401.2,1234.3,401.5z M1277.8,404.5h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1279.4,403.9,1278.7,404.5,1277.8,404.5z
			 M1275.2,401.5h1.1v-1.1h-1.1V401.5z M1269.5,404.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C1271,403.9,1270.4,404.5,1269.5,404.5z M1266.9,401.5h1.1v-1.1h-1.1V401.5z M1261.2,404.5h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1262.7,403.9,1262.1,404.5,1261.2,404.5z
			 M1258.6,401.5h1.1v-1.1h-1.1V401.5z M1252.9,404.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C1254.4,403.9,1253.7,404.5,1252.9,404.5z M1250.3,401.5h1.1v-1.1h-1.1V401.5z M1244.6,404.5h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1246.1,403.9,1245.4,404.5,1244.6,404.5z
			 M1242,401.5h1.1v-1.1h-1.1V401.5z"/>
	</g>
					<text transform="matrix(1 0 0 1 1294.7316 389.2049)" class="st6 st7 st8">2018</text>
					<text transform="matrix(1 0 0 1 1294.7308 407.2957)"><tspan x="0" y="0" class="st9 st6 st10">The first offline store of</tspan><tspan x="0" y="21.1" class="st9 st6 st10">Simon Li Brand</tspan><tspan x="0" y="42.1" class="st9 st6 st10">was opened in China opened</tspan></text>
</g>
				<g class="a5 ani">
	<g>
		<path class="st4" d="M547.2,434.1c-4.6,0-8.3,3.7-8.3,8.3c0,4.6,3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S551.8,434.1,547.2,434.1z
			 M559,440.5h-4.2v4.2h4.2V440.5z M567.3,440.4h-4.2v4.2h4.2V440.4z M575.6,440.4h-4.1v4.2h4.2v-4.2H575.6z M583.9,440.4h-4.2v4.2
			h4.2V440.4z M592.2,440.4H588v4.2h4.2V440.4z M600.6,440.4h-4.2v4.2h4.2V440.4z"/>
		<path class="st5" d="M547.2,452.4c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C554.9,449.8,551.3,452.4,547.2,452.4z M547.2,435.6c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C552.4,437.4,550,435.6,547.2,435.6z M557,443h0.5v-1.1
			H557c0,0.2,0,0.4,0,0.6C557,442.6,557,442.9,557,443z M600.5,446h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C602.1,445.4,601.4,446,600.5,446z M597.9,443h1.1v-1.1h-1.1V443z M592.2,446h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C593.8,445.4,593.1,446,592.2,446z M589.6,443
			h1.1v-1.1h-1.1V443z M583.9,446h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C585.5,445.4,584.8,446,583.9,446z M581.3,443h1.1v-1.1h-1.1V443z M575.6,446h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C577.1,445.4,576.5,446,575.6,446z M573,443h1.1v-1.1H573V443z M567.3,446
			h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C568.8,445.4,568.2,446,567.3,446z
			 M564.7,443h1.1v-1.1h-1.1V443z"/>
	</g>
					<text transform="matrix(1 0 0 1 612.2632 428.8047)" class="st6 st7 st8">1999</text>
					<text transform="matrix(1 0 0 1 612.1392 446.8956)"><tspan x="0" y="0" class="st9 st6 st10">Trayton Shanghai </tspan><tspan x="0" y="21.1" class="st9 st6 st10">Factory was established</tspan></text>
</g>
				<g class="a7 ani">
	<g>
		<path class="st4" d="M875.4,342.8c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S880,342.8,875.4,342.8z M887.3,349
			h-4.2v4.2h4.2V349z M895.6,349h-4.2v4.2h4.2V349z M903.9,349h-4.2v4.2h4.2V349z M912.2,349H908v4.2h4.2V349z M920.5,349h-4.2v4.2
			h4.2V349z M928.8,349h-4.2v4.2h4.2V349z"/>
		<path class="st5" d="M875.4,360.9c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.2,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C883.1,358.4,879.6,360.9,875.4,360.9z M875.4,344.2c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C880.7,346,878.2,344.2,875.4,344.2z M885.3,351.6h0.5
			v-1.1h-0.5c0,0.2,0,0.4,0,0.6C885.3,351.2,885.3,351.5,885.3,351.6z M928.8,354.6h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C930.3,354,929.6,354.6,928.8,354.6z M926.2,351.6h1.1v-1.1h-1.1V351.6z
			 M920.5,354.6h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C922,354,921.3,354.6,920.5,354.6z M917.9,351.6h1.1v-1.1h-1.1V351.6z M912.2,354.6H908c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C913.7,354,913,354.6,912.2,354.6z M909.5,351.6h1.1v-1.1h-1.1V351.6z
			 M903.9,354.6h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C905.4,354,904.7,354.6,903.9,354.6z M901.2,351.6h1.1v-1.1h-1.1V351.6z M895.6,354.6h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C897.1,354,896.4,354.6,895.6,354.6z M892.9,351.6h1.1v-1.1h-1.1V351.6z"/>
	</g>
					<text transform="matrix(1 0 0 1 940.6576 315.2047)" class="st6 st7 st8">2014</text>
					<text transform="matrix(1 0 0 1 940.5336 333.2955)"><tspan x="0" y="0" class="st9 st6 st10">Jiaxing Motion Furniture </tspan><tspan x="0" y="21.1" class="st9 st6 st10">was in production</tspan><tspan x="0" y="42.1" class="st9 st6 st10">started functional sofa research and</tspan><tspan x="0" y="63.2" class="st9 st6 st10">development and manufacturing</tspan></text>
</g>
				<g class="a10 ani">
	<g>
		<path class="st4" d="M1224.5,255.4c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S1229.1,255.4,1224.5,255.4z
			 M1236.3,261.8h-4.2v4.2h4.2V261.8z M1244.6,261.8h-4.2v4.2h4.2V261.8z M1252.9,261.8h-4.2v4.2h4.2V261.8z M1261.2,261.8h-4.2v4.2
			h4.2V261.8z M1269.5,261.8h-4.2v4.2h4.2V261.8z M1277.8,261.8h-4.2v4.2h4.2V261.8z"/>
		<path class="st5" d="M1224.5,273.6c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7
			c0.8,0,1.5,0.7,1.5,1.5v4.2c0,0.8-0.7,1.5-1.5,1.5h-2.7C1232.2,271,1228.6,273.6,1224.5,273.6z M1224.5,257c-3.7,0-6.8,3-6.8,6.8
			c0,3.8,3,6.8,6.8,6.8c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6
			C1229.7,258.8,1227.3,257,1224.5,257z M1234.3,264.4h0.5v-1.1h-0.5c0,0.2,0,0.4,0,0.6C1234.3,263.9,1234.3,264.1,1234.3,264.4z
			 M1277.8,267.4h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1279.4,266.8,1278.7,267.4,1277.8,267.4z M1275.2,264.4h1.1v-1.1h-1.1V264.4z M1269.5,267.4h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1271,266.8,1270.4,267.4,1269.5,267.4z M1266.9,264.4h1.1v-1.1h-1.1V264.4z
			 M1261.2,267.4h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1262.7,266.8,1262.1,267.4,1261.2,267.4z M1258.6,264.4h1.1v-1.1h-1.1V264.4z M1252.9,267.4h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1254.4,266.8,1253.7,267.4,1252.9,267.4z M1250.3,264.4h1.1v-1.1h-1.1
			V264.4z M1244.6,267.4h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1246.1,266.8,1245.4,267.4,1244.6,267.4z M1242,264.4h1.1v-1.1h-1.1V264.4z"/>
	</g>
					<text transform="matrix(1 0 0 1 1294.7312 251.2047)" class="st6 st7 st8">2019</text>
					<text transform="matrix(1 0 0 1 1294.6072 269.2955)"><tspan x="0" y="0" class="st9 st6 st10">A new Jiaxing Motion Factory </tspan><tspan x="0" y="21.1" class="st9 st6 st10">was i inaugurated </tspan><tspan x="0" y="42.1" class="st9 st6 st10">the exhibition hall and R&amp;D </tspan><tspan x="0" y="63.2" class="st9 st6 st10">center were established in Jiaxing</tspan></text>
</g>
				<g class="a13 ani">
	<g>
		<path class="st4" d="M1556.9,211.9c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3
			C1565.2,215.6,1561.5,211.9,1556.9,211.9z M1568.7,218.1h-4.2v4.2h4.2V218.1z M1577,218.1h-4.2v4.2h4.2V218.1z M1585.3,218.1h-4.2
			v4.2h4.2V218.1z M1593.6,218.1h-4.2v4.2h4.2V218.1z M1601.9,218.1h-4.2v4.2h4.2V218.1z M1610.2,218.1h-4.2v4.2h4.2V218.1z"/>
		<path class="st5" d="M1556.9,230.1c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7
			c0.8,0,1.5,0.7,1.5,1.5v4.2c0,0.8-0.7,1.5-1.5,1.5h-2.7C1564.6,227.5,1561,230.1,1556.9,230.1z M1556.9,213.4
			c-3.7,0-6.8,3-6.8,6.8c0,3.7,3.1,6.8,6.8,6.8c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6
			C1562.1,215.1,1559.7,213.4,1556.9,213.4z M1566.7,220.8h0.5v-1.1h-0.5c0,0.2,0,0.4,0,0.6C1566.7,220.4,1566.7,220.6,1566.7,220.8
			z M1610.2,223.8h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1611.8,223.1,1611.1,223.8,1610.2,223.8z M1607.6,220.8h1.1v-1.1h-1.1V220.8z M1601.9,223.8h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1603.4,223.1,1602.8,223.8,1601.9,223.8z M1599.3,220.8h1.1v-1.1h-1.1
			V220.8z M1593.6,223.8h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1595.1,223.1,1594.5,223.8,1593.6,223.8z M1591,220.8h1.1v-1.1h-1.1V220.8z M1585.3,223.8h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1586.8,223.1,1586.2,223.8,1585.3,223.8z M1582.7,220.8h1.1v-1.1h-1.1
			V220.8z M1577,223.8h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1578.5,223.1,1577.8,223.8,1577,223.8z M1574.4,220.8h1.1v-1.1h-1.1V220.8z"/>
	</g>
					<text transform="matrix(1 0 0 1 1628.6886 209.0494)" class="st6 st7 st8">2024</text>
					<text transform="matrix(1 0 0 1 1628.5646 227.1402)"><tspan x="0" y="0" class="st9 st6 st10">The Trayton Group Global </tspan><tspan x="0" y="21.1" class="st9 st6 st10">Manufacturing & R&D Headquarter </tspan><tspan x="0" y="42.1" class="st9 st6 st10">was in production </tspan><tspan x="0" y="63.2" class="st9 st6 st10">The Trayton Mexico Factory was</tspan><tspan x="0" y="83.2" class="st9 st6 st10">in production</tspan></text>
</g>
				<g class="a14 ani">
	<g>
		<path class="st4" d="M1653.1,371.9c0-4.6-3.7-8.3-8.3-8.3c-4.6,0-8.3,3.7-8.3,8.3c0,4.6,3.7,8.3,8.3,8.3
			S1653.1,376.5,1653.1,371.9z M1646.9,384.2V380h-4.2v4.2H1646.9z M1646.9,392.5v-4.2h-4.2v4.2H1646.9z M1646.9,401v-4.2h-4.2v4.2
			H1646.9z M1646.9,409.2V405h-4.2v4.2H1646.9z M1646.9,417.5v-4.2h-4.2v4.2H1646.9z M1646.9,425.9v-4.2h-4.2v4.2H1646.9z
			 M1646.9,434.1v-4.2h-4.2v4.2H1646.9z"/>
		<path class="st5" d="M1646.9,435.6h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1648.4,435,1647.7,435.6,1646.9,435.6z M1644.2,432.6h1.1v-1.1h-1.1V432.6z M1646.9,427.4h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1648.4,426.6,1647.7,427.4,1646.9,427.4z M1644.2,424.4h1.1v-1.1h-1.1
			V424.4z M1646.9,419h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1648.4,418.4,1647.7,419,1646.9,419z M1644.2,416h1.1v-1.1h-1.1V416z M1646.9,410.8h-4.2c-0.8,0-1.5-0.7-1.5-1.5V405
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1648.4,410,1647.7,410.8,1646.9,410.8z M1644.2,407.6h1.1v-1.1h-1.1V407.6z
			 M1646.9,402.5h-4.2c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.4-0.7-0.4-1.1v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1648.4,401.8,1647.7,402.5,1646.9,402.5z M1644.2,399.4h1.1v-1.1h-1.1V399.4z M1646.9,394.1h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1648.4,393.5,1647.7,394.1,1646.9,394.1z M1644.3,391h1.1v-1.1h-1.1V391z
			 M1646.9,385.9h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-3.3c-3.6-1.4-6.2-5-6.2-9.2c0-5.4,4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8
			c0,4.2-2.6,7.7-6.2,9.2v3.3C1648.4,385.1,1647.7,385.9,1646.9,385.9z M1644.3,382.8h1.1v-1.1c-0.4,0-0.7,0-1.1,0V382.8z
			 M1644.2,378.6h1.1c3.5-0.3,6.2-3.2,6.2-6.8c0-3.7-3-6.8-6.8-6.8s-6.8,3-6.8,6.8C1638,375.4,1640.8,378.4,1644.2,378.6z"/>
	</g>
					<text transform="matrix(1 0 0 1 1641.3622 478.6046)" class="st6 st7 st8">2025</text>
					<text transform="matrix(1 0 0 1 1641.2382 496.6955)"><tspan x="0" y="0" class="st9 st6 st10">The Trayton Vietnam Factory was  </tspan><tspan x="0" y="21.1" class="st9 st6 st10">in production </tspan></text>
</g>
				<g class="a12 ani">
	<g>
		<path class="st4" d="M1223.8,143.3c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3c-4.6,0-8.3-3.7-8.3-8.3
			C1215.5,147.1,1219.2,143.3,1223.8,143.3z M1212,149.6h4.2v4.2h-4.2V149.6z M1203.7,149.6h4.2v4.2h-4.2V149.6z M1195.4,149.6h4.2
			v4.2h-4.2V149.6z M1187.1,149.6h4.2v4.2h-4.2V149.6z M1178.8,149.6h4.2v4.2h-4.2V149.6z M1170.4,149.6h4.2v4.2h-4.2V149.6z"/>
		<path class="st5" d="M1223.8,161.4c-4.1,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.4-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8C1233.6,157.1,1229.2,161.4,1223.8,161.4z M1217.6,154.2c1,2.4,3.4,4.1,6.3,4.1
			c3.7,0,6.8-3,6.8-6.8c0-3.7-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2
			C1217.7,153.9,1217.6,154.1,1217.6,154.2z M1213.5,152.1h0.5c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6h-0.5V152.1z M1207.8,155.2h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1209.4,154.6,1208.7,155.2,1207.8,155.2z
			 M1205.2,152.1h1.1V151h-1.1V152.1z M1199.5,155.2h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C1201.1,154.6,1200.4,155.2,1199.5,155.2z M1196.9,152.1h1.1V151h-1.1V152.1z M1191.2,155.2h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1192.7,154.6,1192.1,155.2,1191.2,155.2z
			 M1188.6,152.1h1.1V151h-1.1V152.1z M1182.9,155.2h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C1184.4,154.6,1183.8,155.2,1182.9,155.2z M1180.3,152.1h1.1V151h-1.1V152.1z M1174.6,155.2h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1176.1,154.6,1175.4,155.2,1174.6,155.2z
			 M1172,152.1h1.1V151h-1.1V152.1z"/>
	</g>
					<text transform="matrix(1 0 0 1 1087.5492 135.8044)" class="st6 st7 st8">2020</text>
					<text transform="matrix(1 0 0 1 915.1205 153.8952)"><tspan x="-60" y="0" class="st9 st6 st10">Build the NEST SPACE brand and set up </tspan><tspan x="8.3" y="21.1" class="st9 st6 st10">dozens of retail stores in major </tspan><tspan x="93.3" y="42.1" class="st9 st6 st10">cities across China</tspan></text>
</g>
				<g class="a8 ani">
	<g>
		<path class="st4" d="M875.4,475.8c-4.6,0-8.3,3.7-8.3,8.3c0,4.6,3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S880,475.8,875.4,475.8z
			 M887.3,482h-4.2v4.2h4.2V482z M895.6,482h-4.2v4.2h4.2V482z M903.9,482h-4.2v4.2h4.2V482z M912.2,482H908v4.2h4.2V482z
			 M920.5,482h-4.2v4.2h4.2V482z M928.8,482h-4.2v4.2h4.2V482z"/>
		<path class="st5" d="M875.4,493.9c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.2,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C883.1,491.2,879.6,493.9,875.4,493.9z M875.4,477.2c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C880.7,479,878.2,477.2,875.4,477.2z M885.3,484.5h0.5
			v-1.1h-0.5c0,0.2,0,0.4,0,0.6S885.3,484.5,885.3,484.5z M928.8,487.6h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C930.3,487,929.6,487.6,928.8,487.6z M926.2,484.5h1.1v-1.1h-1.1V484.5z M920.5,487.6h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C922,487,921.3,487.6,920.5,487.6z
			 M917.9,484.5h1.1v-1.1h-1.1V484.5z M912.2,487.6H908c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C913.7,487,913,487.6,912.2,487.6z M909.5,484.5h1.1v-1.1h-1.1V484.5z M903.9,487.6h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C905.4,487,904.7,487.6,903.9,487.6z
			 M901.2,484.5h1.1v-1.1h-1.1V484.5z M895.6,487.6h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C897.1,487,896.4,487.6,895.6,487.6z M892.9,484.5h1.1v-1.1h-1.1V484.5z"/>
	</g>
					<text transform="matrix(1 0 0 1 940.7194 472.9047)" class="st6 st7 st8">2016</text>
					<text transform="matrix(1 0 0 1 940.5954 490.9955)"><tspan x="0" y="0" class="st9 st6 st10">The Simon Li JD Flagship Store</tspan><tspan x="0" y="21.1" class="st9 st6 st10">and Tmall Flagship Store </tspan><tspan x="0" y="42.1" class="st9 st6 st10">officially launched</tspan></text>
</g>
				<g class="a4 ani">
	<g>
		<path class="st4" d="M547.2,571.2c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3C555.5,575,551.8,571.2,547.2,571.2z
			 M559,577.5h-4.2v4.2h4.2V577.5z M567.3,577.5h-4.2v4.2h4.2V577.5z M575.6,577.5h-4.1v4.2h4.2v-4.2H575.6z M583.9,577.5h-4.2v4.2
			h4.2V577.5z M592.2,577.5H588v4.2h4.2V577.5z M600.6,577.5h-4.2v4.2h4.2V577.5z"/>
		<path class="st5" d="M547.2,589.5c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5
			v4.2c0,0.8-0.7,1.5-1.5,1.5h-2.7C554.9,586.8,551.3,589.5,547.2,589.5z M547.2,572.8c-3.7,0-6.8,3-6.8,6.8s3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C552.4,574.5,550,572.8,547.2,572.8z M557,580.2h0.5
			v-1.1H557c0,0.2,0,0.4,0,0.6C557,579.8,557,580,557,580.2z M600.5,583.2h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5
			h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C602.1,582.5,601.4,583.2,600.5,583.2z M597.9,580.2h1.1v-1.1h-1.1V580.2z M592.2,583.2h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C593.8,582.5,593.1,583.2,592.2,583.2z
			 M589.6,580.2h1.1v-1.1h-1.1V580.2z M583.9,583.2h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C585.5,582.5,584.8,583.2,583.9,583.2z M581.3,580.2h1.1v-1.1h-1.1V580.2z M575.6,583.2h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C577.1,582.5,576.5,583.2,575.6,583.2z
			 M573,580.2h1.1v-1.1H573V580.2z M567.3,583.2h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5
			v4.2C568.8,582.5,568.2,583.2,567.3,583.2z M564.7,580.2h1.1v-1.1h-1.1V580.2z"/>
	</g>
					<text transform="matrix(1 0 0 1 612.2632 566.9047)" class="st6 st7 st8">2005</text>
					<text transform="matrix(1 0 0 1 612.1392 584.9955)"><tspan x="0" y="0" class="st9 st6 st10">Trayton Shanghai Factory</tspan><tspan x="0" y="21.1" class="st9 st6 st10">was in production</tspan><tspan x="0" y="42.1" class="st9 st6 st10">and the private brand Simon Li </tspan><tspan x="0" y="63.2" class="st9 st6 st10">was exhibited for the first time in High Point US</tspan></text>
</g>
				<g class="a2 ani">
	<g>
		<path class="st4" d="M252.5,488.1c4.6,0,8.3,3.7,8.3,8.3c0,4.6-3.7,8.3-8.3,8.3c-4.6,0-8.3-3.7-8.3-8.3
			C244.2,492,247.9,488.1,252.5,488.1z M240.7,494.5h4.2v4.2h-4.2V494.5z M232.4,494.5h4.2v4.2h-4.2V494.5z M224.1,494.5h4.2v4.2
			h-4.2V494.5z M215.8,494.5h4.2v4.2h-4.2V494.5z M207.5,494.5h4.2v4.2h-4.2V494.5z M199.2,494.5h4.2v4.2h-4.2V494.5z"/>
		<path class="st5" d="M252.5,506.4c-4.2,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.5-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8C262.4,502,258,506.4,252.5,506.4z M246.3,499.1c1,2.4,3.4,4.1,6.3,4.1
			c3.7,0,6.8-3,6.8-6.8c0-3.7-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2C246.4,498.8,246.4,499,246.3,499.1
			z M242.2,497h0.5c0-0.2,0-0.4,0-0.6s0-0.4,0-0.6h-0.5V497z M236.6,500h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5
			h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C238.1,499.5,237.4,500,236.6,500z M233.9,497h1.1v-1.1h-1.1V497z M228.3,500h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C229.8,499.5,229.1,500,228.3,500z M225.6,497
			h1.1v-1.1h-1.1V497z M219.9,500h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C221.5,499.5,220.8,500,219.9,500z M217.3,497h1.1v-1.1h-1.1V497z M211.6,500h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C213.2,499.5,212.5,500,211.6,500z M209,497h1.1v-1.1H209V497z M203.3,500
			h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C204.9,499.5,204.2,500,203.3,500z
			 M200.7,497h1.1v-1.1h-1.1V497z"/>
	</g>
					<text transform="matrix(1 0 0 1 121.0087 480.6044)" class="st6 st7 st8">1993</text>
					<text transform="matrix(1 0 0 1 6.4291 498.6952)"><tspan x="0" y="0" class="st9 st6 st10">CEO Started his business</tspan><tspan x="62.4" y="21.1" class="st9 st6 st10">career in China</tspan></text>
</g>
				<g class="a3 ani">
	<g>
		<path class="st4" d="M252.5,604.5c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3c-4.6,0-8.3-3.7-8.3-8.3S247.9,604.5,252.5,604.5z
			 M240.7,610.8h4.2v4.2h-4.2V610.8z M232.4,610.8h4.2v4.2h-4.2V610.8z M224.1,610.8h4.2v4.2h-4.2V610.8z M215.8,610.8h4.2v4.2h-4.2
			V610.8z M207.5,610.8h4.2v4.2h-4.2V610.8z M199.2,610.8h4.2v4.2h-4.2V610.8z"/>
		<path class="st5" d="M252.5,622.7c-4.2,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.5-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8S258,622.7,252.5,622.7z M246.3,615.5c1,2.4,3.4,4.1,6.3,4.1c3.7,0,6.8-3,6.8-6.8
			c0-3.7-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2C246.4,615.2,246.4,615.3,246.3,615.5z M242.2,613.3h0.5
			c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6h-0.5V613.3z M236.6,616.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C238.1,615.8,237.4,616.5,236.6,616.5z M233.9,613.3h1.1v-1.1h-1.1V613.3z M228.3,616.5h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C229.8,615.8,229.1,616.5,228.3,616.5z
			 M225.6,613.3h1.1v-1.1h-1.1V613.3z M219.9,616.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C221.5,615.8,220.8,616.5,219.9,616.5z M217.3,613.3h1.1v-1.1h-1.1V613.3z M211.6,616.5h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C213.2,615.8,212.5,616.5,211.6,616.5z
			 M209,613.3h1.1v-1.1H209V613.3z M203.3,616.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5
			v4.2C204.9,615.8,204.2,616.5,203.3,616.5z M200.7,613.3h1.1v-1.1h-1.1V613.3z"/>
	</g>
					<text transform="matrix(1 0 0 1 121.0087 595.5045)" class="st6 st7 st8">1995</text>
					<text transform="matrix(1 0 0 1 83.1298 613.5953)"><tspan x="0" y="0" class="st9 st6 st10">Trayton Group</tspan><tspan x="10.7" y="21.1" class="st9 st6 st10">was founded</tspan></text>
</g>
</svg>
			<svg version="1.1" id="svg-mob-new" class="mobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
					 viewBox="0 0 343 919.8" style="enable-background:new 0 0 343 919.8;" xml:space="preserve">
				<g>
	<path class="st0 "  d="M261.9,50v28c0,21.6-17.7,39.3-39.3,39.3H82.5 M203.4,269.3h-134c-21.6,0-39.3-17.7-39.3-39.3v-73.4
		c0-21.6,17.7-39.3,39.3-39.3h19.7 M153.6,421.3h109.6c21.6,0,39.3-17.7,39.3-39.3v-73.4c0-21.6-17.7-39.3-39.3-39.3h-62.1
		 M241.2,733.4h49.2c21.6,0,39.3-17.7,39.3-39.3v-73.4c0-21.6-17.7-39.3-39.3-39.3h-19.7 M274.8,886.4h-49.2
		c-21.6,0-39.3-17.7-39.3-39.3v-74.4c0-21.6,17.7-39.3,39.3-39.3h19.7 M271.2,581.3H152.1c-21.6,0-39.3-17.7-39.3-39.3v-81.4
		c0-21.6,17.7-39.3,39.3-39.3h3.7"/>
</g>
				<path class="st1 orange-long-mobile" d="M261.9,50v28c0,21.6-17.7,39.3-39.3,39.3H82.5h6.6H69.4c-21.6,0-39.3,17.7-39.3,39.3V230
	c0,21.6,17.7,39.3,39.3,39.3h134h-2.3h62.1c21.6,0,39.3,17.7,39.3,39.3V382c0,21.6-17.7,39.3-39.3,39.3H153.6h2.2h-3.7
	c-21.6,0-39.3,17.7-39.3,39.3V542c0,21.6,17.7,39.3,39.3,39.3h119.1l-0.5,0.1h19.7c21.6,0,39.3,17.7,39.3,39.3v73.4
	c0,21.6-17.7,39.3-39.3,39.3h-49.2h4.1h-19.7c-21.6,0-39.3,17.7-39.3,39.3v74.4c0,21.6,17.7,39.3,39.3,39.3h49.2"/>
				<circle class="st2" cx="282.2" cy="886.4" r="7.3"/>
				<circle class="st2" cx="261.9" cy="42.9" r="7.3"/>
				<g class="a4-mobile ani">
					<circle class="st2" cx="228.4" cy="218" r="3.6"/>
					<text transform="matrix(1 0 0 1 236.3669 209.2465)" class="st7 st8">1997</text>
					<text transform="matrix(1 0 0 1 237.2194 220.9416)"><tspan x="0" y="0" class="st9 st7 st10">A small workshop was</tspan><tspan x="0" y="10" class="st9 st7 st10">established to produce</tspan><tspan x="0" y="20" class="st9 st7 st10">sofas with Boconcept</tspan></text>
					<path class="st5" d="M132.4,265.1v-21.8h96v-21.8"/>
	<circle class="st3" cx="132.4" cy="269.5" r="7.5"/>
					<circle class="st3" cx="132.4" cy="269.5" r="6.1"/>
					<circle class="st4" cx="132.4" cy="269.5" r="4.4"/>
</g>


				<g>
	<path class="st6" d="M82.4,681.4v-22.1c0-5.1-4.1-9.2-9.2-9.2H29.6c-5.1,0-9.2,4.1-9.2,9.2v22.1H82.4L82.4,681.4z"/>
					<path class="st6" d="M20.4,667.2h29.1c1,0,1.9,0.6,1.9,1.5v11.1"/>
					<path class="st6" d="M82.4,667.2H53.3c-1,0-1.9,0.6-1.9,1.5v11.1"/>
					<path class="st6" d="M20.4,667.6c0,0-1.3-1.9-4.1-1.7c-2.8,0.3-3.3,2.2-3.6,3.1c-0.3,0.9,0,16.7,0,16.7s0.1,2.2,3.8,2.2H88
		c0,0,2.6-0.1,2.6-2.7v-15.4c0-1.3-0.6-2.7-1.8-3.3c-0.8-0.5-1.8-0.8-3.1-0.5c-1.8,0-3.2,1.3-3.2,2.6 M84.7,687.9v7.4
		c0,0.9-0.6,1.5-1.5,1.5h-2c-0.9,0-1.5-0.6-1.5-1.5v-7.4 M23,687.9v7.4c0,0.9-0.6,1.5-1.5,1.5h-2c-0.9,0-1.5-0.6-1.5-1.5v-7.4"/>
</g>
				<g>
	<path class="st6" d="M84,199.1c0,6.9-5.6,12.4-12.4,12.4c-6.9,0-12.4-5.5-12.4-12.4s5.5-12.4,12.4-12.4c4,0,7.5,1.9,9.8,4.8
		 M71.5,190.1v8.1 M72.2,200.1l4,4.1"/>
					<circle class="st6" cx="71.6" cy="199.1" r="1"/>
					<path class="st6" d="M79.8,191.7l1.9,0.4l0.2-2"/>
					<path class="st6" d="M92.4,175.3H95c2.9,0,5.3,2.4,5.3,5.3v35c0,3-2.4,5.3-5.3,5.3H47.9c-2.9,0-5.3-2.4-5.3-5.3v-35
		c0-2.9,2.4-5.3,5.3-5.3h3.7 M59.5,175.3H84"/>
					<path class="st6" d="M56.3,168.8h-1.2c-1.7,0-3.1,1.4-3.1,3.1v5.4c0,1.7,1.4,3.1,3.1,3.1h1.2c1.7,0,3.1-1.4,3.1-3.1v-5.4
		C59.5,170.2,58.1,168.8,56.3,168.8z M88.8,168.8h-1.2c-1.7,0-3.1,1.4-3.1,3.1v5.4c0,1.7,1.4,3.1,3.1,3.1h1.2c1.7,0,3.1-1.4,3.1-3.1
		v-5.4C92,170.2,90.6,168.8,88.8,168.8z"/>
</g>
				<g>
	<path class="st6" d="M232.1,407.1l2.7-25.6h5.4l0.8,8.5"/>
					<path class="st6" d="M239.5,407.1v-17.8l11,5.8v-5.8l10.4,5.8v-5.8h11.7v17.8 M249.9,369.1c0,0-4.1-3.6-7.1-0.9
		c-1.8,1.6-1.2,6-1.2,6s0-0.1-0.1-0.1c-0.9-1.8-3.5-1.3-3.2,1.2c0.1,0.3,0.3,0.7,0.5,1c-1.8-0.4-2.4,1.1-1.8,2.3
		c-2-0.3-1.9,2.5-0.8,2.9 M239,381.2c0,0,1-0.8,0.3-2.4c2,0.1,2.7-0.3,2.9-2.2c2.5,0.7,3.2-0.1,3.5-1.6c0.6,1.2,2,2.4,3.4,1.5
		c1.5-1,0.8-3.3,0.6-3.9"/>
					<path class="st6" d="M241,407.1v-2.3h4.8v2.3 M251.3,407.1v-2.3h4.8v2.3 M261.6,407.1v-2.3h4.8v2.3 M226.9,407.1h50.4v4.3h-50.4
		V407.1z M262.4,391h2.5v1.5h-2.5V391z M262.4,393.9h2.5v1.5h-2.5V393.9z M268.5,391h2.5v1.5h-2.5V391z M268.5,393.9h2.5v1.5h-2.5
		V393.9z"/>
</g>

				<g class="a1-mobile ani">
	<g>
		<circle class="st3" cx="229.7" cy="116.7" r="7.5"/>
		<circle class="st3" cx="229.7" cy="116.7" r="6.1"/>
		<circle class="st4" cx="229.7" cy="116.7" r="4.4"/>
	</g>
					<circle class="st2" cx="229.7" cy="71.7" r="3.6"/>
					<path class="st5" d="M229.7,111.7V74.6"/>
					<text transform="matrix(1 0 0 1 195.2596 34.1522)" class="st7 st8">1987</text>
					<text transform="matrix(1 0 0 1 174.7902 45.2524)"><tspan x="0" y="0" class="st9 st7 st10">CEO came Shanghai</tspan><tspan x="-2.7" y="10" class="st9 st7 st10">to study Chinese and</tspan><tspan x="13.2" y="20" class="st9 st7 st10">Chinese culture</tspan></text>
</g>
				<g class="a2-mobile ani">
	<g>
		<circle class="st3" cx="120.5" cy="116.7" r="7.5"/>
		<circle class="st3" cx="120.5" cy="116.7" r="6.1"/>
		<circle class="st4" cx="120.5" cy="116.7" r="4.4"/>
	</g>
					<circle class="st2" cx="120.5" cy="71.7" r="3.6"/>
					<path class="st5" d="M120.5,111.7V74.6"/>
					<text transform="matrix(1 0 0 1 72.1651 66.2298)" class="st7 st8">1993</text>
					<g>
		<text transform="matrix(1 0 0 1 0.1381 74.983)"><tspan x="0" y="0" class="st9 st7 st10">CEO Started his business</tspan><tspan x="28" y="10" class="st9 st7 st10">career in China</tspan></text>
	</g>
</g>
				<g class="a3-mobile ani">
	<g>
		<circle class="st3" cx="82.5" cy="269.5" r="7.5"/>
		<circle class="st3" cx="82.5" cy="269.5" r="6.1"/>
		<circle class="st4" cx="82.5" cy="269.5" r="4.4"/>
	</g>
					<circle class="st2" cx="82.5" cy="313.9" r="3.6"/>
					<path class="st5" d="M82.5,273.9V311"/>
					<text transform="matrix(1 0 0 1 90.9001 305.8465)" class="st7 st8">1995</text>
					<g>
		<text transform="matrix(1 0 0 1 92.3001 316.5)"><tspan x="0" y="0" class="st9 st7 st10">Trayton Group</tspan><tspan x="0" y="10" class="st9 st7 st10">was founded</tspan></text>
	</g>
</g>
				<g>

</g>
				<g class="a5-mobile ani">
	<g>
		<circle class="st3" cx="188.9" cy="269.5" r="7.5"/>
		<circle class="st3" cx="188.9" cy="269.5" r="6.1"/>
		<circle class="st4" cx="188.9" cy="269.5" r="4.4"/>
	</g>
					<circle class="st2" cx="188.9" cy="313.9" r="3.6"/>
					<path class="st5" d="M188.9,273.9V311"/>
					<text transform="matrix(1 0 0 1 183.4976 337.5966)" class="st7 st8">1999</text>
					<g>
		<text transform="matrix(1 0 0 1 186.3024 347.7491)"><tspan x="0" y="0" class="st9 st7 st10">Trayton Shanghai </tspan><tspan x="0" y="10" class="st9 st7 st10">Factory was established</tspan></text>
	</g>
</g>
				<g class="a6-mobile ani">
	<g>

			<ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -232.8312 281.6924)" class="st3" cx="223.6" cy="421.9" rx="7.5" ry="7.5"/>
		<circle class="st3" cx="223.6" cy="421.9" r="6.1"/>
		<circle class="st4" cx="223.6" cy="421.9" r="4.4"/>
	</g>
					<circle class="st2" cx="223.6" cy="466.3" r="3.6"/>
					<path class="st5" d="M223.6,426.3v37"/>
					<text transform="matrix(1 0 0 1 209.3279 493.5408)" class="st7 st8">2005</text>
					<g>
		<text transform="matrix(1 0 0 1 209.3284 506.0592)"><tspan x="0" y="0" class="st9 st7 st10">Trayton Shanghai Factory</tspan><tspan x="0" y="10" class="st9 st7 st10">was in production</tspan><tspan x="0" y="20" class="st9 st7 st10">and the private brand Simon Li </tspan><tspan x="0" y="30" class="st9 st7 st10">was exhibited for </tspan><tspan x="0" y="40" class="st9 st7 st10">the first time in High Point US</tspan></text>
	</g>
</g>
				<g class="a7-mobile ani">
	<g>
		<circle class="st3" cx="164" cy="421.9" r="7.5"/>
		<circle class="st3" cx="164" cy="421.9" r="6.1"/>
		<circle class="st4" cx="164" cy="421.9" r="4.4"/>
	</g>
					<circle class="st2" cx="163.9" cy="391.3" r="3.6"/>
					<path class="st5" d="M163.9,394.3v22.4"/>
					<text transform="matrix(1 0 0 1 117.0652 367.9507)" class="st7 st8">2014</text>
					<g>
		<text transform="matrix(1 0 0 1 64.8523 378.8714)"><tspan x="0" y="0" class="st9 st7 st10">Jiaxing Motion Furniture</tspan><tspan x="-3.1" y="10" class="st9 st7 st10">was in production started</tspan><tspan x="-12.1" y="20" class="st9 st7 st10"> functional sofa research and</tspan><tspan x="-27" y="30" class="st9 st7 st10"> development and manufacturing</tspan></text>
	</g>
</g>
				<g class="a8-mobile ani">
	<g>
		<circle class="st3" cx="112.7" cy="491.1" r="7.5"/>
		<circle class="st3" cx="112.7" cy="491.1" r="6.1"/>
		<circle class="st4" cx="112.7" cy="491.1" r="4.4"/>
	</g>
					<circle class="st2" cx="81.9" cy="491.1" r="3.6"/>
					<path class="st5" d="M107.3,491.1H85.5"/>
					<text transform="matrix(1 0 0 1 64.5651 444.6937)" class="st7 st8">2016</text>
					<g>
		<text transform="matrix(1 0 0 1 5.891 456.3154)"><tspan x="0" y="0" class="st9 st7 st10">The Simon Li JD Flagship Store</tspan><tspan x="17.5" y="10" class="st9 st7 st10">and Tmall Flagship Store</tspan><tspan x="36.1" y="20" class="st9 st7 st10">officially launched</tspan></text>
	</g>
</g>
				<g class="a9-mobile ani">
	<g>
		<circle class="st3" cx="113.1" cy="533.3" r="7.5"/>
		<circle class="st3" cx="113.1" cy="533.3" r="6.1"/>
		<circle class="st4" cx="113.1" cy="533.3" r="4.4"/>
	</g>
					<circle class="st2" cx="82.9" cy="581.3" r="3.6"/>
					<path class="st5" d="M105.7,533.3H95.5v47.9h-6.9"/>
					<text transform="matrix(1 0 0 1 78.3001 610.0465)" class="st7 st8">2018</text>
					<g>
		<text transform="matrix(1 0 0 1 53.5618 619.1)"><tspan x="0" y="0" class="st9 st7 st10">The first offline store of</tspan><tspan x="23.2" y="10" class="st9 st7 st10">Simon Li Brand</tspan><tspan x="-17.9" y="20" class="st9 st7 st10">was opened in China opened</tspan></text>
	</g>
</g>
				<g class="a10-mobile ani">
	<g>
		<circle class="st3" cx="330" cy="615.5" r="7.5"/>
		<circle class="st3" cx="330" cy="615.5" r="6.1"/>
		<circle class="st4" cx="330" cy="615.5" r="4.4"/>
	</g>
					<circle class="st2" cx="285.6" cy="615.5" r="3.6"/>
					<path class="st5" d="M325.6,615.5h-37.1"/>
					<text transform="matrix(1 0 0 1 235.5652 607.7468)" class="st7 st8">2019</text>
					<g>
		<text transform="matrix(1 0 0 1 179.2057 617.5999)"><tspan x="0" y="0" class="st9 st7 st10">A new Jiaxing Motion Factory</tspan><tspan x="34" y="10" class="st9 st7 st10">was i inaugurated</tspan><tspan x="6.2" y="20" class="st9 st7 st10">the exhibition hall and R&amp;D</tspan><tspan x="-12.3" y="30" class="st9 st7 st10">center were established in Jiaxing</tspan></text>
	</g>
</g>
				<g class="a11-mobile ani">
	<g>
		<circle class="st3" cx="330" cy="697" r="7.5"/>
		<circle class="st3" cx="330" cy="697" r="6.1"/>
		<circle class="st4" cx="330" cy="697" r="4.4"/>
	</g>
					<circle class="st2" cx="285.6" cy="697" r="3.6"/>
					<path class="st5" d="M325.6,697h-37.1"/>
					<text transform="matrix(1 0 0 1 235.5652 679.8792)" class="st7 st8">2020</text>
					<g>
		<text transform="matrix(1 0 0 1 171.4538 690.8997)"><tspan x="-26" y="0" class="st9 st7 st10">Build the NEST SPACE brand and set up </tspan><tspan x="4.5" y="10" class="st9 st7 st10">dozens of retail stores in major </tspan><tspan x="42.1" y="20" class="st9 st7 st10">cities across China</tspan></text>
	</g>
</g>
				<g class="a12-mobile ani">
	<g>
		<circle class="st3" cx="186.3" cy="773.2" r="7.5"/>
		<circle class="st3" cx="186.3" cy="773.2" r="6.1"/>
		<circle class="st4" cx="186.3" cy="773.2" r="4.4"/>
	</g>
					<circle class="st2" cx="234.5" cy="773.1" r="3.6"/>
					<path class="st5" d="M190.4,773.2h38.9"/>
					<text transform="matrix(1 0 0 1 217.8892 798.9076)" class="st7 st8">2024</text>
					<g>
		<text transform="matrix(1 0 0 1 217.8893 811.0522)"><tspan x="0" y="0" class="st9 st7 st10">The Trayton Group Global </tspan><tspan x="0" y="10" class="st9 st7 st10">Manufacturing &amp; R&amp;D Headquarter </tspan><tspan x="0" y="20" class="st9 st7 st10">was in production</tspan><tspan x="0" y="30" class="st9 st7 st10">The Trayton Mexico Factory was</tspan><tspan x="0" y="40" class="st9 st7 st10">in production</tspan></text>
	</g>
</g>
				<g class="a13-mobile ani">
	<g>
		<circle class="st3" cx="186.3" cy="823.1" r="7.5"/>
		<circle class="st3" cx="186.3" cy="823.1" r="6.1"/>
		<circle class="st4" cx="186.3" cy="823.1" r="4.4"/>
	</g>
					<circle class="st2" cx="141.9" cy="823.1" r="3.6"/>
					<path class="st5" d="M181.9,823.1h-37.1"/>
					<text transform="matrix(1 0 0 1 93.0972 811.92)" class="st7 st8">2025</text>
					<g>
		<text transform="matrix(1 0 0 1 47.4061 825.4297)"><tspan x="-25" y="0" class="st9 st7 st10">The Trayton Vietnam Factory was
</tspan><tspan x="42" y="10" class="st9 st7 st10">in production
</tspan><tspan x="1.8" y="20" class="st9 st7 st10"></tspan></text>
	</g>
</g>
</svg>
		</div>
</template>

<script>
    export default {
        name: 'History',
        methods: {
            test() {
                console.log(this.$refs['orange-long-mobile'].getTotalLength())
            }
        },
        mounted() {
            // this.test()
        }
    }
</script>

<style lang="scss" scoped>
    @use 'styles/varibles' as *;
    @use 'styles/common' as *;

    .history {
        margin: 13rem auto 0;
        width: 90%;
    }

    .title {
        margin: 0 0 0 0;
        opacity: 0;
    }

    .title-cn {
        margin: 1rem 0 5rem 0;
        letter-spacing: 1rem;
        opacity: 0;
    }

    .mobile-svg {
        display: none;
    }

    .orange-long {
        stroke-dasharray: 0, 1767.353271484375;
        stroke-dashoffset: 0;
    }
    .blue-long {
        //stroke-dasharray: 0, 1767.353271484375;
        stroke-dasharray: 0, 3560.72412109375;
        stroke-dashoffset: 0;
    }
    .orange-long-mobile {
        stroke-dasharray: 0, 1824.46142578125;
        stroke-dashoffset: 0;
    }

    .line-1,
    .line-2,
    .line-3,
    .line-5,
    .line-6,
    .line-7,
    .line-8,
    .line-9,
    .line-11,
    .line-12,
    .line-13,
    .line-14,
    {
        stroke-dasharray: 0, 37;
    }

    .line-4 {
        stroke-dasharray: 0, 139.60000610351562;
    }

    .line-10 {
        stroke-dasharray: 0, 85.70004272460938;
    }

    .line-1-mobile,
    .line-2-mobile,
    .line-3-mobile,
    {
        stroke-dasharray: 0, 37.099998474121094;
    }

    .line-4-mobile,
    {
        stroke-dasharray: 0, 139.60000610351562;
    }

    .line-5-mobile,
    {
        stroke-dasharray: 0, 37.100006103515625;
    }

    .line-6-mobile {
        stroke-dasharray: 0, 37;
    }

    .line-7-mobile {
        stroke-dasharray: 0, 37.100006103515625;
    }

    .line-8-mobile {
        stroke-dasharray: 0, 22.399993896484375;
    }

    .line-9-mobile {
        stroke-dasharray: 0, 21.800003051757812;
    }

    .line-10-mobile {
        stroke-dasharray: 0, 65.0000228881836;
    }

    .line-11-mobile,
    .line-12-mobile,
    .line-13-mobile,
    {
        stroke-dasharray: 0, 37.100006103515625;
    }

    .line-14-mobile,
    {
        stroke-dasharray: 0, 38.899993896484375;
    }

    .orange-1,
    .orange-1-mobile,
    .circle-1,
    .circle-1-mobile,
    .t1987,
    .t1987-mobile,
    .orange-2,
    .orange-2-mobile,
    .circle-2,
    .circle-2-mobile,
    .t1993,
    .t1993-mobile,
    .clock,
    .clock-mobile,
    .orange-3,
    .orange-3-mobile,
    .circle-3,
    .circle-3-mobile,
    .t1994,
    .t1994-mobile,
    .orange-4,
    .orange-4-mobile,
    .circle-4,
    .circle-4-mobile,
    .t1995,
    .t1995-mobile,
    .orange-5,
    .orange-5-mobile,
    .circle-5,
    .circle-5-mobile,
    .t1997,
    .t1997-mobile,
    .sofa,
    .sofa-mobile,
    .orange-6,
    .orange-6-mobile,
    .circle-6,
    .circle-6-mobile,
    .t1999,
    .t1999-mobile,
    .orange-7,
    .orange-7-mobile,
    .circle-7,
    .circle-7-mobile,
    .t2002,
    .t2002-mobile,
    .orange-8,
    .orange-8-mobile,
    .circle-8,
    .circle-8-mobile,
    .t2006,
    .t2006-mobile,
    .orange-9,
    .orange-9-mobile,
    .circle-9,
    .circle-9-mobile,
    .t2012,
    .t2012-mobile,
    .factory,
    .factory-mobile,
    .orange-10,
    .orange-10-mobile,
    .circle-10,
    .circle-10-mobile,
    .t2014,
    .t2014-mobile,
    .orange-11,
    .orange-11-mobile,
    .circle-11,
    .circle-11-mobile,
    .t2016,
    .t2016-mobile,
    .orange-12,
    .orange-12-mobile,
    .circle-12,
    .circle-12-mobile,
    .t2018,
    .t2018-mobile,
    .orange-13,
    .orange-13-mobile,
    .circle-13,
    .circle-13-mobile,
    .t2019-1,
    .t2019-1-mobile,
    .orange-14,
    .orange-14-mobile,
    .circle-14,
    .circle-14-mobile,
    .t2019-2,
    .t2019-2-mobile,
    {
        opacity: 0;
    }

    .animate .title {
        animation: fadeInUp .5s linear forwards;
    }

    .animate .title-cn {
        animation: fadeInUp .5s .3s linear forwards;
    }

    .animate .orange-long {
        animation: orange-long 10s .5s linear forwards;
    }
		.animate .orange-long-mobile {
			animation: orange-long-mobile 10s .5s linear forwards;
		}
    .animate .blue-long, .animate .blue-long-mobile {
        animation: blue-long 10s .5s linear forwards;
    }
    .animate .orange-1,
    .animate .orange-1-mobile,
    {
        animation: opacityIn .2s 1s linear forwards;
    }

    .animate .line-1,
    .animate .line-1-mobile {
        animation: line-1 .2s 1.2s linear forwards;
    }

    .animate .circle-1,
    .animate .circle-1-mobile,
    {
        animation: opacityIn .2s 1.4s linear forwards;
    }

    .animate .t1987,
    .animate .t1987-mobile,
    {
        animation: opacityIn .2s 1.6s linear forwards;
    }
    .animate .ani {
      opacity: 0;
      animation: opacityIn linear forwards;
      animation-duration: .2s;
    }
    .animate .b1 {
      animation-delay: 1.5s;
    }

    .animate .a1
    {
      animation-delay: 1.6s;
    }
    .animate .b1-mobile, .animate .a1-mobile {
      animation-delay: .8s;
    }
    .animate .b2
    {
      animation-delay: 1.7s;
    }
    .animate .b2-mobile,.animate .a2-mobile
    {
      animation-delay: 1.2s;
    }
    .animate .a2,
    {
      animation-delay: 1.8s;
    }
    .animate .b3,
    {
      animation-delay: 1.9s;
    }
    .animate .b3-mobile,
    .animate .a3-mobile,
    {
      animation-delay: 2.4s;
    }
    .animate .a3,
    {
      animation-delay: 2s;
    }
    .animate .b4,
    .animate .b4-mobile,
    {
      animation-delay: 3s;
    }
    .animate .a4,
    .animate .a4-mobile,
    {
      animation-delay: 3.1s;
    }
    .animate .b5,
    .animate .b5-mobile,
    {
      animation-delay: 3.4s;
    }
    .animate .a5,
    .animate .a5-mobile,
    {
      animation-delay: 3.5s;
    }
    .animate .b6,
    {
      animation-delay: 3.6s;
    }
    .animate .a6-mobile,
    .animate .b6-mobile {
      animation-delay: 4.6s;
    }
    .animate .a6,
    {
      animation-delay: 3.7s;
    }
    .animate .b7,
    .animate .b7-mobile,
    {
      animation-delay: 5.3s;
    }
    .animate .a7,
    .animate .a7-mobile,
    {
      animation-delay: 5.4s;
    }
    .animate .b8,
    .animate .b8-mobile,
    {
      animation-delay: 5.5s;
    }
    .animate .a8,
    .animate .a8-mobile,
    {
      animation-delay: 5.6s;
    }
    .animate .b9,
    .animate .b9-mobile,
    {
      animation-delay: 7.3s;
    }
    .animate .a9,
    .animate .a9-mobile,
    {
      animation-delay: 7.4s;
    }
    .animate .b9,
    .animate .b9-mobile,
    {
      animation-delay: 7.3s;
    }
    .animate .a9,
    .animate .a9-mobile,
    {
      animation-delay: 7.4s;
    }
    .animate .b10
    {
      animation-delay: 7.5s;
    }
    .animate .b10-mobile,
    .animate .a10-mobile {
      animation-delay: 8s;
    }
    .animate .a10
    {
      animation-delay: 7.6s;
    }
    .animate .b11,

    {
      animation-delay: 7.8s;
    }
    .animate .a11,
    {
      animation-delay: 7.9s;
    }
    .animate .a11-mobile,
    .animate .b11-mobile,
    {
      animation-delay: 8.5s;
    }
    .animate .b12,

    {
      animation-delay: 9s;
    }
    .animate .a12,
    {
      animation-delay: 8.1s;
    }
    .animate .a12-mobile,
    .animate .b12-mobile {
      animation-delay: 9s;
    }
    .animate .b13,
    {
      animation-delay: 9.2s;
    }
    .animate .a13-mobile,
    .animate .b13-mobile {
      animation-delay: 9.5s;
    }
    .animate .a13
    {
      animation-delay: 9.3s;
    }
    .animate .b14,
    {
      animation-delay: 9.8s;
    }
    .animate .a14-mobile,
    .animate .b14-mobile {
      animation-delay: 9s;
    }
    .animate .a15-mobile,
    .animate .b15-moble {
      animation-delay: 9.5s;
    }
    .animate .a14,
    {
      animation-delay: 9.9s;
    }
    .animate .orange-2,
    .animate .orange-2-mobile,
    {
        animation: opacityIn .2s 1.4s linear forwards;
    }

    .animate .line-2,
    .animate .line-2-mobile,
    {
        animation: line-1 .2s 1.6s linear forwards;
    }

    .animate .circle-2,
    .animate .circle-2-mobile,
    {
        animation: opacityIn .2s 1.8s linear forwards;
    }

    .animate .t1993,
    .animate .t1993-mobile,
    {
        animation: opacityIn .2s 2s linear forwards;
    }

    .animate .clock,
    .animate .clock-mobile,
    {
        animation: opacityIn .2s 2.2s linear forwards;
    }

    .animate .orange-3,
    .animate .orange-3-mobile,
    {
        animation: opacityIn .2s 2.6s linear forwards;
    }

    .animate .line-3,
    .animate .line-3-mobile,
    {
        animation: line-1 .2s 2.8s linear forwards;
    }

    .animate .circle-3,
    .animate .circle-3-mobile,
    {
        animation: opacityIn .2s 3s linear forwards;
    }

    .animate .t1994,
    .animate .t1994-mobile,
    {
        animation: opacityIn .2s 3.2s linear forwards;
    }

    .animate .orange-4,
    .animate .orange-4-mobile,
    {
        animation: opacityIn .2s 3s linear forwards;
    }

    .animate .line-4,
    .animate .line-4-mobile,
    {
        animation: line-4 .2s 3.2s linear forwards;
    }

    .animate .circle-4,
    .animate .circle-4-mobile,
    {
        animation: opacityIn .2s 3.4s linear forwards;
    }

    .animate .t1995,
    .animate .t1995-mobile,
    {
        animation: opacityIn .2s 3.6s linear forwards;
    }

    .animate .orange-5,
    .animate .orange-5-mobile,
    {
        animation: opacityIn .2s 3.4s linear forwards;
    }

    .animate .line-5,
    .animate .line-5-mobile,
    {
        animation: line-4 .2s 3.6s linear forwards;
    }

    .animate .circle-5,
    .animate .circle-5-mobile,
    {
        animation: opacityIn .2s 3.8s linear forwards;
    }

    .animate .t1997,
    .animate .t1997-mobile,
    {
        animation: opacityIn .2s 4s linear forwards;
    }

    .animate .sofa,
    .animate .sofa-mobile,
    {
        animation: opacityIn .3s 4.2s linear forwards;
    }

    .animate .orange-6,
    .animate .orange-6-mobile,
    {
        animation: opacityIn .2s 4.8s linear forwards;
    }

    .animate .line-6,
    .animate .line-6-mobile,
    {
        animation: line-1 .2s 5s linear forwards;
    }

    .animate .circle-6,
    .animate .circle-6-mobile,
    {
        animation: opacityIn .2s 5.2s linear forwards;
    }

    .animate .t1999,
    .animate .t1999-mobile,
    {
        animation: opacityIn .2s 5.4s linear forwards;
    }

    .animate .orange-7,
    .animate .orange-7-mobile,
    {
        animation: opacityIn .2s 5s linear forwards;
    }

    .animate .line-7,
    .animate .line-7-mobile,
    {
        animation: line-1 .2s 5.2s linear forwards;
    }

    .animate .circle-7,
    .animate .circle-7-mobile,
    {
        animation: opacityIn .2s 5.4s linear forwards;
    }

    .animate .t2002,
    .animate .t2002-mobile,
    {
        animation: opacityIn .2s 5.6s linear forwards;
    }

    .animate .orange-8,
    .animate .orange-8-mobile,
    {
        animation: opacityIn .2s 5.4s linear forwards;
    }

    .animate .line-8,
    .animate .line-8-mobile,
    {
        animation: line-1 .2s 5.6s linear forwards;
    }

    .animate .circle-8,
    .animate .circle-8-mobile,
    {
        animation: opacityIn .2s 5.8s linear forwards;
    }

    .animate .t2006,
    .animate .t2006-mobile,
    {
        animation: opacityIn .2s 6s linear forwards;
    }

    .animate .orange-9,
    .animate .orange-9-mobile,
    {
        animation: opacityIn .2s 6.6s linear forwards;
    }

    .animate .line-9,
    .animate .line-9-mobile,
    {
        animation: line-1 .2s 7s linear forwards;
    }

    .animate .circle-9,
    .animate .circle-9-mobile,
    {
        animation: opacityIn .2s 7.2s linear forwards;
    }

    .animate .t2012,
    .animate .t2012-mobile,
    {
        animation: opacityIn .2s 7.4s linear forwards;
    }

    .animate .factory,
    .animate .factory-mobile,
    {
        animation: opacityIn .2s 7.6s linear forwards;
    }

    .animate .orange-10,
    .animate .orange-10-mobile,
    {
        animation: opacityIn .2s 7.4s linear forwards;
    }

    .animate .line-10,
    .animate .line-10-mobile,
    {
        animation: line-10 .2s 7.6s linear forwards;
    }

    .animate .circle-10,
    .animate .circle-10-mobile,
    {
        animation: opacityIn .2s 7.8s linear forwards;
    }

    .animate .t2014,
    .animate .t2014-mobile,
    {
        animation: opacityIn .2s 8s linear forwards;
    }

    .animate .orange-11,
    .animate .orange-11-mobile,
    {
        animation: opacityIn .2s 7.8s linear forwards;
    }

    .animate .line-11,
    .animate .line-11-mobile,
    {
        animation: line-1 .2s 8s linear forwards;
    }

    .animate .circle-11,
    .animate .circle-11-mobile,
    {
        animation: opacityIn .2s 8.2s linear forwards;
    }

    .animate .t2016,
    .animate .t2016-mobile,
    {
        animation: opacityIn .2s 8.4s linear forwards;
    }

    .animate .orange-12,
    .animate .orange-12-mobile,
    {
        animation: opacityIn .2s 8.6s linear forwards;
    }

    .animate .line-12,
    .animate .line-12-mobile,
    {
        animation: line-1 .2s 8.8s linear forwards;
    }

    .animate .circle-12,
    .animate .circle-12-mobile,
    {
        animation: opacityIn .2s 9s linear forwards;
    }

    .animate .t2018,
    .animate .t2018-mobile,
    {
        animation: opacityIn .2s 9.2s linear forwards;
    }

    .animate .orange-13,
    .animate .orange-13-mobile,
    {
        animation: opacityIn .2s 9.4s linear forwards;
    }

    .animate .line-13,
    .animate .line-13-mobile,
    {
        animation: line-1 .2s 9.6s linear forwards;
    }

    .animate .circle-13,
    .animate .circle-13-mobile,
    {
        animation: opacityIn .2s 9.8s linear forwards;
    }

    .animate .t2019-1,
    .animate .t2019-1-mobile,
    {
        animation: opacityIn .2s 10s linear forwards;
    }

    .animate .orange-14,
    .animate .orange-14-mobile,
    {
        animation: opacityIn .2s 9.8s linear forwards;
    }

    .animate .line-14,
    .animate .line-14-mobile,
    {
        animation: line-1 .2s 10s linear forwards;
    }

    .animate .circle-14,
    .animate .circle-14-mobile,
    {
        animation: opacityIn .2s 10.2s linear forwards;
    }

    .animate .t2019-2,
    .animate .t2019-2-mobile {
        animation: opacityIn .2s 10.4s linear forwards;
    }

    @keyframes orange-long {
        100% {
            stroke-dasharray: 1767.353271484375, 1767.353271484375;
        }
    }

    @keyframes blue-long {
        100% {
            stroke-dasharray: 3560.72412109375, 3560.72412109375;
        }
    }
    @keyframes orange-long-mobile {
        100% {
            stroke-dasharray: 1824.46142578125, 1824.46142578125;
        }
    }

    @keyframes line-1 {
        100% {
            stroke-dasharray: 3, 3;
        }
    }

    @keyframes line-4 {
        100% {
            stroke-dasharray: 3, 3;
        }
    }

    @keyframes line-10 {
        100% {
            stroke-dasharray: 3, 3;
        }
    }

    @media screen and (max-width: 750px) {
        .history {
            margin: 3rem auto 0;
            width: 90%;
        }
        .title-cn {
            margin: 1rem 0 3rem 0;
        }
        .pc-svg {
            display: none;
        }
        .mobile-svg {
            display: block;
        }

    }
		#svg-pc-new .st0{clip-path:url(#SVGID_00000176727918303748170990000016355884292667388545_);}
		#svg-pc-new .st1{display:none;fill:#006483;}
		#svg-pc-new .st2{fill:none;stroke:#006287;stroke-width:2;stroke-miterlimit:10;}
		#svg-pc-new .st3{fill:none;stroke:#B7B7B7;stroke-miterlimit:10;}
		#svg-pc-new .st4{fill:#006483;}
		#svg-pc-new .st5{display:none;fill:#595959;}
		#svg-pc-new .st6{font-family:AvantGarde;}
		#svg-pc-new .st7{font-size:31.5938px;}
		#svg-pc-new .st8{letter-spacing:1;}
		#svg-pc-new .st9{fill:#666666;}
		#svg-pc-new .st10{font-size:16px;}

		#svg-mob-new .st0{fill:none;stroke:#A3A3A3;stroke-miterlimit:10;}
		#svg-mob-new .st1{fill:none;stroke:#006287;stroke-miterlimit:10;}
		#svg-mob-new .st2{fill:none;stroke:#898989;stroke-miterlimit:10;}
		#svg-mob-new .st3{opacity:0.2;fill:#006287;enable-background:new    ;}
		#svg-mob-new .st4{fill:#006287;}
		#svg-mob-new .st5{fill:none;stroke:#231815;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:4;}
		#svg-mob-new .st6{fill:none;stroke:#B7B7B7;stroke-miterlimit:10;}
		#svg-mob-new .st7{font-family: AvantGarde;}
		#svg-mob-new .st8{font-size:18px;}
		#svg-mob-new .st9{fill:#666666;}
		#svg-mob-new .st10{font-size:7px;}
</style>
